import { Fragment } from 'react';
import { useDataTable } from '../../../shared/hooks/DataTable';
import { BankService as Service } from './BankService';
import { useDialogCrup } from '../../../shared/hooks/DialogCrup';
import { useToolbar } from '../../../shared/hooks/Toolbar';

export const List = () => {
  const header = 'Ngân hàng thụ hưởng';
  const dataKey = 'id';
  const { render: renderDataTable, refreshLazyData, reloadLazyData, selectedItems } = useDataTable({
    header,
    dataKey,
    columns: [
      { field: 'code', header: 'Ngân hàng thụ hưởng', width: '25%', matchMode: 'contains' },
      { field: 'bankAccount', header: 'Số tài khoản', width: '25%', matchMode: 'contains' },
      { field: 'accountName', header: 'Tên tài khoản', width: '25%' },
      { field: 'isDefault', header: 'Tài khoản thụ hưởng chính', width: '25%', matchMode: 'equals', filterType: 'boolean', dataType: 'boolean' },
    ],
    indexColumnWidth: 40,
    getList: (params) => {
      return Service.getList(params);
    }
  });

  const { render: renderDialogCrup, create, update, clone } = useDialogCrup({
    header,
    dataKey,
    width: '40rem',
    fields: [
      { field: 'code', header: 'Ngân hàng thụ hưởng', required: true, uppercase: true, className: 'md:col-12' },
      { field: 'bankAccount', header: 'Số tài khoản', required: true, className: 'md:col-12' },
      { field: 'accountName', header: 'Tên tài khoản', className: 'md:col-12' },
      { field: 'isDefault', header: 'Tài khoản thụ hưởng chính', type: 'Checkbox', className: 'md:col-12' }

    ],
    createItem: (item) => {
      return Service.create(item);
    },
    updateItem: (id, item) => {
      return Service.update(id, item);
    },
    refreshLazyData
  });

  const { renderToolbar } = useToolbar({
    dataKey, create, update, clone, reloadLazyData, selectedItems,
    deleteItem(id: string): Promise<any> {
      return Service.delete(id);
    },
    // deleteItems(ids: Array<any>): Promise<any> {
    //   return Service.deleteMulti(ids);
    // }
  });



  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}
      {renderDialogCrup()}
    </Fragment>
  )
}
